import { stringify } from 'qs';
import { Environment } from 'utils/Environment';

export const SHOPLESS_RESELLER_ID = 'SHOPLESS';

type ChannelInfo = {
  chainAgent?: string;
  salesforcePartnerId?: string;
};

export const fetchChannelInfoFromCos = async (resellerId?: string, chainAgent?: string) => {
  if (!resellerId)
    return {
      chainAgent,
      salesforcePartnerId: undefined,
    };

  if (resellerId === SHOPLESS_RESELLER_ID) return undefined;

  const requestQueryParams = {
    requestedAgentId: chainAgent || undefined,
  };
  return Environment.current.cosApiClient
    .get<ChannelInfo>(
      `/v3/shop/resellers/${resellerId}/chain_agent_id${stringify(requestQueryParams, {
        addQueryPrefix: true,
      })}`,
    )
    .then(response => {
      const { chainAgent, salesforcePartnerId } = response.data;
      return { chainAgent, salesforcePartnerId };
    })
    .catch(() => {
      console.error(`Failed to get chain agent id from server for resellerId ${resellerId}`);
      return undefined;
    });
};
